import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import logo from './Includes/Images/Final_logo_Black.png';
import './App.css';
import Internet from './Components/Internet';
import ViasatProvider from './Components/Providers/ViasatProvider';
import RCNProvider from './Components/Providers/RCNProvider';
import SmithvilleProvider from './Components/Providers/SmithvilleProvider';
import FidiumProvider from './Components/Providers/FidiumProvider';
import VerizonProvider from './Components/Providers/VerizonProvider';
import DirectvProvider from './Components/Providers/DirectvProvider';
import HghesnetProvider from './Components/Providers/HghesnetProvider';
import ADTProvider from './Components/Providers/ADTProvider';
import ZiplyfiberProvider from './Components/Providers/ZiplyfiberProvider';
import MetronetProvider from './Components/Providers/MetronetProvider';
import XfinityInternet from './Components/Providers/XfinityInternet';
import XfinityTv from './Components/Providers/XfinityTv';
import SpectermInternet from './Components/Providers/SpectermInternet';
import SpectermTv from './Components/Providers/SpectermTv';
import EarthlinkProvider from './Components/Providers/EarthlinkProvider';
import AttProvider from './Components/Providers/AttProvider';
import TopInfoBar from './Components/TopInfoBar';
import { LanguageChange } from './Components/LanguageChange';
import CoxProvider from './Components/Providers/CoxProvider';
import KineticsProvider from './Components/Providers/KineticsProvider';
import About from './Components/About';
import FAQ from './Components/FAQ';

// Lazy load components to improve initial load performance
const Home = lazy(() => import('./Components/Home'));
const Plans = lazy(() => import('./Components/Plans'));
const Contact = lazy(() => import('./Components/Contact'));
const Services = lazy(() => import('./Components/Services'));
const TvCable = lazy(() => import('./Components/TvCable'));
const Streaming = lazy(() => import('./Components/Streaming'));
const PrivacyPolicy = lazy(() => import('./Components/PrivacyPolicy'));
const TermsAndConditions = lazy(() => import('./Components/TermsAndConditions'));

// Provider components
const XfinityProvider = lazy(() => import('./Components/Providers/XfinityProvider'));
const SpectrumProvider = lazy(() => import('./Components/Providers/SpectermProvider'));
const WowProvider = lazy(() => import('./Components/Providers/WowProvider'));
const OptimumProvider = lazy(() => import('./Components/Providers/OptimumProvider'));
const AltafiberProvider = lazy(() => import('./Components/Providers/AltafiberProvider'));
const WindstreamProvider = lazy(() => import('./Components/Providers/WinStreamProvider'));

// Loading fallback component
const LoadingFallback = () => (
  <div className="loading-fallback">
    <div className="loading-spinner"></div>
  </div>
);

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <LanguageChange>
      <div className="App">
        {showSplash ? (
          <div className="splash-screen">
            <div className="splash-content">
              <img src={logo} className="logo-2" alt="Symzitech Solutions Logo" />
              <div className="loader"></div>
            </div>
          </div>
        ) : (
          <BrowserRouter>
            {/* This will always be visible regardless of route changes */}
            {/* <TopInfoBar /> */}
            
            <Suspense fallback={<LoadingFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Plans" element={<Plans />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/services" element={<Services />} />
                <Route path="/cable-tv" element={<TvCable />} />
                <Route path="/streaming" element={<Streaming />} />
                <Route path="/xfinity" element={<XfinityProvider />} />
                <Route path="/xfinity-internet" element={<XfinityInternet />} />
                <Route path="/xfinity-tv" element={<XfinityTv />} />
                <Route path="/spectrum" element={<SpectrumProvider />} />
                <Route path="/spectrum-internet" element={<SpectermInternet />} />
                <Route path="/spectrum-tv" element={<SpectermTv />} />
                <Route path="/earthlink" element={<EarthlinkProvider />} />
                <Route path="/wow" element={<WowProvider />} />
                <Route path="/att" element={<AttProvider />} />
                <Route path="/optimum" element={<OptimumProvider />} />
                <Route path="/windstream" element={<WindstreamProvider />} />
                <Route path="/altafiber" element={<AltafiberProvider />} />
                <Route path="/viasat" element={<ViasatProvider />} />
                <Route path="/rcn" element={<RCNProvider />} />
                <Route path="/smithville" element={<SmithvilleProvider />} />
                <Route path="/fidium" element={<FidiumProvider />} />
                <Route path="/verizon" element={<VerizonProvider />} />
                <Route path="/directv" element={<DirectvProvider />} />
                <Route path="/hughesnet" element={<HghesnetProvider />} />
                <Route path="/adt" element={<ADTProvider />} />
                <Route path="/ziplyfiber" element={<ZiplyfiberProvider />} />
                <Route path="/metronet" element={<MetronetProvider />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/term-and-conditions" element={<TermsAndConditions />} />
                <Route path="/cox" element={<CoxProvider />} />
                <Route path="/kinetic" element={<KineticsProvider />} />
                <Route path="/internet" element={<Internet />} />
                <Route path="/about" element={<About />} />
                <Route path="/faqs" element={<FAQ />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        )}
      </div>
    </LanguageChange>
  );
}

export default App;